<template>
  <v-card flat class="pa-4" :style="{ backgroundColor: cardBg }">
    <v-card-title class="text-h6">
      Configurare AD
    </v-card-title>
    <v-divider class="my-2"></v-divider>

    <DxDataGrid
      ref="dataGridRef"
      :data-source="adSettings"
      :show-borders="true"
      :show-column-lines="false"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :hover-state-enabled="true"
      :column-auto-width="true"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :remote-operations="false"
      @row-inserting="onRowInserting"
      @row-updating="onRowUpdating"
      @row-removing="onRowRemoving"
    >
      <DxSearchPanel :visible="true" placeholder="Caută..." />
      <DxColumnChooser :enabled="true" />
      <DxPaging :page-size="10" />
      <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10,20,50]" show-info />
      <DxEditing :allow-updating="true" :allow-adding="true" :allow-deleting="true" mode="popup">
        <DxPopup title="Configurare AD" :show-title="true" :width="560" height="auto"
          :wrapper-attr="{ class: 'era-edit-popup' }" />
        <DxForm :col-count="2" />
      </DxEditing>

      <DxColumn data-field="Hostname" caption="Server (host)" />
      <DxColumn data-field="Port" caption="Port" :width="90" />
      <DxColumn data-field="UserName" caption="Utilizator" />
      <DxColumn data-field="PasswordCipher" caption="Parolă" :customize-text="maskPass"
        :editor-options="{ mode: 'password' }" />
      <DxColumn data-field="Domain" caption="Domeniu" />
      <DxColumn data-field="DomainName" caption="Nume domeniu" />
      <DxColumn data-field="DomainDistinguishedName" caption="Domeniu (DN)" :visible="false" />
      <DxColumn data-field="SearchBase" caption="Search Base" :visible="false" />
      <DxColumn data-field="ContainerName" caption="Container" :visible="false" />
      <DxColumn data-field="SearchProperty" caption="Proprietate căutare" :visible="false" />
      <DxColumn caption="" :width="140" cell-template="testCell" />

      <template #testCell="{ data }">
        <DxButton text="Testează AD" icon="link" styling-mode="outlined" @click="testAd(data.data)" />
      </template>
    </DxDataGrid>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import DxDataGrid, { DxColumn, DxPaging, DxPager, DxEditing, DxSearchPanel, DxColumnChooser, DxPopup, DxForm } from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import ADServices from "@/services/AUTH/AD_Services";

export default defineComponent({
  name: "ADTab",
  components: { DxDataGrid, DxColumn, DxPaging, DxPager, DxEditing, DxSearchPanel, DxColumnChooser, DxPopup, DxForm, DxButton },
  setup() {
    const adSettings = ref<any[]>([]);
    const dataGridRef = ref<any>(null);
    const cardBg = "#f9f9f9";
    const maskPass = (v: string) => (v ? "••••••••" : "");

    const loadSettings = () => {
      ADServices.getSettings()
        .then(res => {
          adSettings.value = res.data;
        })
        .catch(console.error);
    };

    const onRowInserting = async (e: any) => {
      try {
        await ADServices.createSetting(e.data);
        loadSettings();
      } catch (err) {
        console.error(err);
      }
    };

    const onRowUpdating = async (e: any) => {
      try {
        await ADServices.updateSetting(e.key.id, e.newData);
        loadSettings();
      } catch (err) {
        console.error(err);
        e.cancel = true;
      }
    };

    const onRowRemoving = async (e: any) => {
      try {
        await ADServices.deleteSetting(e.data.id);
        loadSettings();
      } catch (err) {
        console.error(err);
        e.cancel = true;
      }
    };

    const testAd = async (row: any) => {
      try {
        const res = await ADServices.testAd({
          DomainName: row.DomainName,
          UserName: row.UserName,
          PasswordCipher: row.PasswordCipher,
        });
        notify(res.data?.message || (res.data?.ok ? "Conexiune AD reușită." : "Conexiune AD eșuată."),
          res.data?.ok ? "success" : "error", 4000);
      } catch (e: any) {
        notify(e?.response?.data?.message || "Eroare la testarea AD.", "error", 4000);
      }
    };

    onMounted(loadSettings);

    return { adSettings, dataGridRef, cardBg, maskPass, testAd, onRowInserting, onRowUpdating, onRowRemoving };
  }
});
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}
</style>
